<template>
    <div class="terms-use-page">
        <IdSection :title="titleIdSection" />

        <main>
            <div class="container">
                <div class="terms">
                    <TermsUseContent />
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import NavBarPP from '@/ui/navbar-pp/NavBarPP'
import IdSection from '@/pages/public/components/landing-page/id-section/IdSection'
import TermsUseContent from '@/pages/public/terms-use-page/terms-use-content/TermsUseContent'

export default {
    components: { NavBarPP, IdSection, TermsUseContent },
    data() {
        return {
            titleIdSection: 'Termos de Uso'
        }
    }
}
</script>

<style scope src="./TermsUsePage-light-theme.css"></style>
<style scope src="./TermsUsePage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/terms-use-page/TermsUsePage.vue